module.exports = __webpack_public_path__ + "static/img/thank_you_mail_1.13e4680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shipping/thank_you_mail_1.png
// module id = cyL2
// module chunks = 150